module.exports = __webpack_public_path__ + "static/img/aboutUsc.6a58107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUsc.png
// module id = W+zG
// module chunks = 1